module.exports = __webpack_public_path__ + "static/media/arrangements2.143244c0.jpg";